export default __webpack_public_path__ + "static/media/wifi.99f58663.png";